import React from 'react';
import Spinner from 'react-spinner';

import fetchContent from '../../helpers/backend-communication';
import NationalContactsContentList from './NationalContactsContentList';

export default class NationalContactsContent extends React.Component {
  constructor(props) {
    super(props);

    this.mostRecentQueryString = null;

    this.state = {
      data: null,
      isLoading: false
    };
  }

  requestData(options) {
    const { country, group } = options;
    const queryStringArray = [];

    if (country && country.length > 0) {
      queryStringArray.push(`country=${country}`);
    }

    if (group && group.length > 0 && group !== 'GLOBAL') {
      queryStringArray.push(`region=${group}`);
    }

    const queryString = (queryStringArray.length > 0)
      ? `?${queryStringArray.join('&')}`
      : '';

    if (queryString !== this.mostRecentQueryString) {
      this.mostRecentQueryString = queryString;

      this.setState({
        isLoading: true
      });

      console.log('Fetching National Points of Contact data...');
      fetchContent('npcComplete', queryString)
        .then(responseObject => {
          this.onRequestComplete(responseObject, queryString, options)
        })
        .catch(error => {
          this.setState({
            isLoading: false,
            data: null
          });
          console.error('Fetch of NPC went wrong', error);
        });
    }
  }

  onRequestComplete(data, queryString, options) {
    if (this.mostRecentQueryString !== queryString || !data) return null;

    if (options.group && options.group.length > 0) {
      data = Object.values(Object.values(data).reduce((acc, obj) => Object.assign(acc, obj), {}))
      data.sort((countryA, countryB) => {
        if (countryA.countryName < countryB.countryName) return -1;
        if (countryA.countryName > countryB.countryName) return 1;
        return 0;
      });
    } else {
      data = [data];
    }

    this.setState({
      data,
      isLoading: false
    });
  }

  componentDidMount() {
    this.requestData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) this.requestData(nextProps);
  }

  renderContent(data) {
    return data.map((item, index) => {
      return (
        <div className="national-contacts__country" key={ index }>
          { (index !== 0) ? <hr className="national-contacts__separator" /> : null }
          <h3 className="national-contacts__header">
            { item.countryName }
          </h3>
          <NationalContactsContentList
            data={ item }
            type={ this.props.type }
          />
          <div className="national-contacts__source">
            <strong> Source: </strong> Report of <strong>{ item.lastReport }</strong>
          </div>
        </div>
      );
    });
  }

  renderNoContact() {
    return (
      <p>No contact information available.</p>
    );
  }

  renderHeader(data) {
    return (
      <p>
        {data.length} results found.
      </p>
    );
  };

  render() {
    const { data, isLoading } = this.state;
    let content;

    if (isLoading) {
      content = <Spinner className="national-contacts__spinner" />
    } else if (data) {
      content = this.renderContent(data);
      const header = this.renderHeader(data);
      content = (
        <div>
          {header}
          {content}
        </div>
      )
    } else {
      content = this.renderNoContact();
    }

    return (
      <div className="national-contacts__container">
        { content }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NationalContacts/NationalContactsContent.js